module.exports = __webpack_public_path__ + "img/battery-charging.75100ee8.svg";